module.exports = __webpack_public_path__ + "img/ty1.8f27b0a2.png";